import { Lightning } from "@lightningjs/sdk";
import { Card } from "../base/Card";
import { FOCUS_TRANSITION } from "../base/focus";
import { WATCH_BLUE, watchAsset, watchText } from "./styles";
/** Shared action and team selector, with separate selected and focused states. */
export class WatchButton extends Lightning.Component {
    static _template() {
        return {
            w: 357,
            h: 70,
            Selected: {
                w: 357,
                h: 70,
                alpha: 0,
                rect: true,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: 8,
                    fillColor: 0x4dffffff,
                    stroke: 1,
                    strokeColor: 0x99ffffff,
                },
            },
            Focus: {
                w: 357,
                h: 70,
                alpha: 0,
                rect: true,
                color: Card.BORDER_COLOR,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
            },
            Content: {
                x: 178.5,
                y: 38,
                mount: 0.5,
                flex: { direction: "row", alignItems: "center" },
                Icon: { visible: false, flexItem: { marginRight: 10 } },
                Label: { text: watchText("", 32, 0) },
            },
        };
    }
    set label(label) {
        this.tag("Content.Label").patch({ text: { text: label } });
    }
    set selected(selected) {
        this.tag("Selected").setSmooth("alpha", selected ? 1 : 0, FOCUS_TRANSITION);
    }
    set icon(icon) {
        const plus = icon === "plus";
        this.tag("Content.Icon").patch({
            visible: true,
            // Align the plus with the visible capitals, excluding the text padding.
            y: plus ? -4 : 0,
            w: plus ? 15.52 : 50,
            h: plus ? 15.52 : 50,
            flexItem: { marginRight: plus ? 10 : 8 },
            texture: Lightning.Tools.getSvgTexture(watchAsset(`${icon}.svg`), plus ? 32 : 100, plus ? 32 : 100),
        });
    }
    _focus() {
        this.tag("Focus").setSmooth("alpha", 1, FOCUS_TRANSITION);
        this.tag("Content.Label").setSmooth("color", WATCH_BLUE, FOCUS_TRANSITION);
        // The plus is monochrome; keep club logos in their original colours.
        if (this.tag("Content.Icon").w < 20)
            this.tag("Content.Icon").setSmooth("color", WATCH_BLUE, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.tag("Focus").setSmooth("alpha", 0, FOCUS_TRANSITION);
        this.tag("Content.Label").setSmooth("color", 0xffffffff, FOCUS_TRANSITION);
        this.tag("Content.Icon").setSmooth("color", 0xffffffff, FOCUS_TRANSITION);
    }
}
export default WatchButton;
//# sourceMappingURL=WatchButton.js.map